import { registerModule } from '../../common/framework/service/module_service';
import { SpaceModule } from './module/space/SpaceModule';

export function registerFrameworkModules() {
    registerModule(new SpaceModule());
}
